module.exports = __webpack_public_path__ + "img/ac243fa.png";